import { LampuSellerLogoWhite } from "@/assets/logo/lampu-seller-logo";

export const Header = () => {
  return (
    <header className="bg-humble-blue-500 h-[76px] mb-36 py-[14px] px-6">
      <div className="max-w-[1440px] mx-auto">
        <LampuSellerLogoWhite />
      </div>
    </header>
  );
};
